module.exports = __webpack_public_path__ + "img/electronic_enabled.061de99d.svg";